import {Component, EventEmitter, OnInit} from '@angular/core';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {

  searchString: string;

  constructor(private searchService: SearchService) {
    searchService.doReset.subscribe(() => {
      this.cancelSearch();
    });
  }

  ngOnInit() {
    this.searchString = null;
  }

  updateSearch() {
    this.searchService.searchTerm = this.searchString;
  }

  cancelSearch() {
    this.searchString = null;
    this.searchService.searchTerm = null;
  }

}
